import { Directive, HostListener, Output, EventEmitter } from '@angular/core';

@Directive({
   selector: '[devToolsEnabler]'
})
export class DevToolsEnablerDirective {
   @Output() magicSpell = new EventEmitter<void>();

   private static readonly MAGIC_SEQUENCE = ['KeyD','KeyE','KeyV','KeyD','KeyE','KeyV'];

   private isHovered = false;
   private keySequence: string[] = [];

   @HostListener('mouseenter')
   onMouseEnter() {
      this.isHovered = true;
   }

   @HostListener('mouseleave')
   onMouseLeave() {
      this.isHovered = false;
      this.keySequence = [];
   }

   @HostListener('document:keydown', ['$event'])
   handleKeyboardEvent(event: KeyboardEvent) {
      if (!this.isHovered) {
         return;
      }

      this.keySequence.push(event.code); // Remember this key

      // Only remember enough keys to comapre with magic sequence
      if (this.keySequence.length > DevToolsEnablerDirective.MAGIC_SEQUENCE.length) {
         this.keySequence.shift();
      }

      // See if the magic sequence was entered
      if (this.keySequence.join(',') === DevToolsEnablerDirective.MAGIC_SEQUENCE.join(',')) {
         this.magicSpell.emit();
         this.keySequence = [];
      }
   }
}
